import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckActivity = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 305176e-10,
		width: 40,
		height: 40,
		rx: 20,
		fill: "#3DD394"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M26 15.8972L18.4801 23.1892C18.0789 23.5783 17.4367 23.563 17.0545 23.1553L14 19.8972",
		stroke: "white",
		strokeWidth: 1.5,
		strokeLinecap: "square"
	})]
});
export default SvgCheckActivity;
